// @flow strict

import * as React from 'react';
import styled from 'styled-components'
import { Button } from '@material-ui/core';
import { auth , provider} from '../firebase';

function Login() {
    const signIn = ()=>{
        auth.signInWithPopup(provider).catch((error)=>(
            alert(error.message)
        ));
    };
    return (
        <LoginContainer>
            <LoginInContainer>
                <img src='https://th.bing.com/th/id/OIP.2fssRx8_6vkz0S2stwObVgHaHa?pid=ImgDet&rs=1'/>
                <h1>Sign In to the PAPA Fam</h1>
                <p>papa.slack.com</p>
                <Button onClick={()=>signIn()}>Sign in with  Google</Button>
            </LoginInContainer>
            
        </LoginContainer>
    );
};

export default Login;

const LoginContainer = styled.div`
    background-color:  #f8f8f8;
    height: 100vh;
    display: grid;
    place-items: center;

`

const LoginInContainer = styled.div`
    padding:100px;
    text-align: center;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

    > img{
        object-fit: contain;
        height: 100px;
        margin-bottom: 40px;
    }
    > Button {
        margin-top: 50px;
        text-transform: inherit !important ;
        background-color: #0aBd48 !important;
        color: white;
    }
`